import React, { useState } from 'react';
import styled from 'styled-components';
import { UnmountClosed } from 'react-collapse';
import Header from './Header';
import Link from '../../../../../../../shared/components/Link';
import AdditionalServicesLoader from './AdditionalServicesLoader';
import { CarServiceIcon, NextIcon } from '@kvdbil/components';
import { AlignIcon } from '../../../../../../../shared/components/Layout/AlignIcon';
import { ServiceContainer } from '..';
import { CMSDataObjectPageService } from '~/App/views/ObjectPage/cmsDataHandlers';
import { ServiceStructuredText } from './ServiceStructuredText';

interface Props {
  cmsData?: CMSDataObjectPageService;
}

const LinkWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: ${({ theme }) => theme.typography.fontBaseBoldWeight};
  padding-top: 1rem;
`;

const CollapseContent = styled.div`
  padding: 1rem;
`;

const ServiceAgreement = ({ cmsData }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(isExpanded => !isExpanded);

  if (!cmsData) {
    return <AdditionalServicesLoader service="Service agreement" />;
  }

  const ariaControls = 'additional-service-agreement-content';

  return (
    <ServiceContainer>
      <Header
        icon={cmsData?.icon ?? CarServiceIcon}
        isExpanded={expanded}
        toggleExpanded={toggleExpanded}
        responsiveImage={cmsData?.image?.responsiveImage}
        title={cmsData?.title ?? ''}
        description={cmsData?.description ?? ''}
        ariaControls={ariaControls}
      />
      <UnmountClosed isOpened={expanded}>
        <CollapseContent id={ariaControls}>
          <ServiceStructuredText data={cmsData?.content} />

          <LinkWrapper>
            <Link to={cmsData?.link?.[0]?.url} target="_blank">
              <AlignIcon left={0.15}>
                {cmsData?.link?.[0]?.text}
                <NextIcon />
              </AlignIcon>
            </Link>
          </LinkWrapper>
        </CollapseContent>
      </UnmountClosed>
    </ServiceContainer>
  );
};

export default ServiceAgreement;
